/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    purpose: {
      type: 'variant',
      values: [ 'offer', 'default', 'editorial', 'subtle' ]
    },
    wrap: { type: 'variant', values: [ true ] }
  },
  rules: [
    {
      if: { purpose: 'editorial' },
      tokens: { backgroundColor: '#ffad00' }
    },
    {
      if: { purpose: 'offer' },
      tokens: { backgroundColor: '#7a3dfc', fontColor: '#ffffff' }
    },
    {
      if: { purpose: 'subtle' },
      tokens: { backgroundColor: '#a1ed00' }
    },
    { if: { wrap: true }, tokens: { paddingBottom: 6, paddingTop: 6 } }
  ],
  tokens: {
    backgroundColor: '#a1ed00',
    borderRadius: 4,
    borderRadiusBottomLeft: null,
    borderRadiusBottomRight: null,
    boxShadowColor: null,
    boxShadowPaddingBottom: null,
    boxShadowPaddingLeft: null,
    boxShadowPaddingRight: null,
    boxShadowPaddingTop: null,
    curveAfterBackgroundColor: null,
    curveAfterHeight: null,
    curveAfterRadius: null,
    curveAfterWidth: null,
    curveBackgroundColor: null,
    curveHeight: null,
    curveMarginTop: null,
    curveWidth: null,
    fontColor: '#000000',
    fontName: 'StagSans',
    fontSize: 14,
    fontWeight: '600',
    gradient: null,
    lineHeight: 1.42857142857,
    paddingBottom: 2,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 2
  }
}
export default theme
